import { Card, Row, Col } from 'react-bootstrap';
import Flex from '@/components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconItem from '@/components/common/icon/IconItem';
import StatsChart from './StatsChart';
import { getColor } from '@/helpers/utils';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export type CrmStatItem = {
  id: number | string;
  title: string;
  amount: number;
  target: string;
  icon: IconProp;
  caret?: IconProp;
  color: string;
  caretColor: string;
  data: number[];
};

const StatsItem = ({ stat }: { stat: CrmStatItem }) => {
  const { icon, color, title, amount, caret, caretColor, target, data } = stat;
  return (
    <>
      <Flex alignItems="center" className="mb-3">
        <IconItem
          tag="div"
          icon={icon}
          bg={color}
          color="white"
          size="sm"
          iconClass="fs--2"
          className="me-2 shadow-none"
        />
        <h6 className="mb-0 flex-1">{title}</h6>
      </Flex>
      <Flex alignItems="center" dir="ltr">
        <div className="flex-shrink-0 ps-4">
          <p className="font-sans-serif lh-1 mb-1 fs-3 fw-bold text-nowrap">{amount}%</p>
          {target ? (
            <p className="fs--2 mb-0 text-nowrap d-inline-flex align-items-center gap-1">
              {caret ? (
                <FontAwesomeIcon icon={caret} className={`text-${caretColor}`} />
              ) : null}
              {target}
            </p>
          ) : null}
        </div>
        <div className="w-100" style={{ minWidth: '3.5rem' }}>
          <StatsChart color={getColor(color)} data={data} />
        </div>
      </Flex>
    </>
  );
};

function colLg(count: number) {
  if (count <= 1) return 12;
  return 12 / Math.min(count, 4);
}

/** Falcon `components/dashboards/crm/CrmStats.js`, adapted to one card per stat. */
const CrmStats = ({ stats }: { stats: CrmStatItem[] }) => {
  const lg = colLg(stats.length);

  return (
    <Row className="g-3">
      {stats.map((stat) => (
        <Col lg={lg} key={stat.id}>
          <Card className="h-100">
            <Card.Body className="p-3">
              <StatsItem stat={stat} />
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default CrmStats;
